import React from 'react';

const STATUS_CONFIG = {
  ELIGIBLE:     { bg: 'var(--color-bg-active)',      color: 'var(--color-text-muted)' },
  ASSIGNED:     { bg: 'var(--color-indigo-light)',    color: 'var(--color-indigo-dark)' },
  STAGED:       { bg: 'var(--color-warning-light)',   color: 'var(--color-warning-dark)' },
  ON_SHIPMENT:  { bg: 'var(--color-accent-light)',    color: 'var(--color-accent-dark)' },
  SHIPPED:      { bg: 'var(--color-success-light)',   color: 'var(--color-success-dark)' },
  WRITTEN_OFF:  { bg: 'var(--color-danger-light)',    color: 'var(--color-danger-dark)' },
};

function formatLabel(status) {
  return status.split('_').map(w => w.charAt(0) + w.slice(1).toLowerCase()).join(' ');
}

export default function DisposalStatusBadge({ status }) {
  if (!status) return null;
  const key = status.toUpperCase();
  const cfg = STATUS_CONFIG[key] || STATUS_CONFIG.ELIGIBLE;
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center',
      padding: 'var(--space-1) var(--space-4)',
      borderRadius: 'var(--radius-pill)',
      fontSize: 'var(--text-2xs)', fontWeight: 'var(--font-semibold)',
      whiteSpace: 'nowrap', lineHeight: '1.4',
      background: cfg.bg, color: cfg.color,
    }}>
      {formatLabel(key)}
    </span>
  );
}
